import MPhoneNumber from './MPhoneNumber.vue';

MPhoneNumber.install = (app) => {
  app.component('MPhoneNumber', MPhoneNumber);
};

export { MPhoneNumber };
